import { SET_AUTH_URLS, SET_USER_ROLES } from "../actions/action";

export const initialUrlsSate = {
  urlList: new Set(),
  userRole: "",
};

export const authUrlsReducer = (state, action) => {
  switch (action.type) {
    case SET_AUTH_URLS: {
      return {
        ...state,
        urlList: action.payload,
      };
    }
    case SET_USER_ROLES: {
      return {
        ...state,
        userRole: action.payload,
      };
    }

    default: {
      return state;
    }
  }
};
